import React from 'react';
import { Text } from '@morressier/ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandWave } from '@fortawesome/pro-light-svg-icons';
import { faSquarePen } from '@fortawesome/pro-regular-svg-icons';
import {
  MissingProfileIndicatorContent,
  MissingProfileIndicatorIcon,
  MissingProfileIndicatorTextContent,
  UpdateButton
} from './styles';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
interface IMissingProfileIndicator {
  handleAction: () => void;
  title: string;
  description: string;
  actiontitle: string;
  icon?: IconProp;
  actionIcon?: IconProp;
  iconColor?: string;
  backgroundColor?: string;
}

const MissingProfileIndicator = (props: IMissingProfileIndicator) => {
  const {
    handleAction,
    title,
    description,
    actiontitle,
    icon = faHandWave,
    actionIcon = faSquarePen,
    iconColor,
    backgroundColor
  } = props;
  return (
    <MissingProfileIndicatorContent
      gap="1rem"
      backgroundColor={backgroundColor}
    >
      <MissingProfileIndicatorIcon icon={icon} iconColor={iconColor} />
      <MissingProfileIndicatorTextContent>
        <Text size="body1_new" fontWeight="semiBold">
          {title}
        </Text>
        <Text size="body1_new">{description}</Text>
        <UpdateButton onClick={handleAction} fontWeight={500}>
          <FontAwesomeIcon icon={actionIcon} />
          {actiontitle}
        </UpdateButton>
      </MissingProfileIndicatorTextContent>
    </MissingProfileIndicatorContent>
  );
};

export default MissingProfileIndicator;
